<template>
  <section class="reg-data">
    <div class="container">
      <div class="reg-block d-flex justify-content-between">
        <div class="reg-item d-flex justify-content-center flex-grow-1 align-items-center">
          <h3>{{summary.today}}</h3>
          <p>登録日</p>
        </div>
        <div class="reg-item d-flex justify-content-center flex-grow-1 align-items-center">
          <h3>{{summary.total}}</h3>
          <p>登録人数</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ApiService from '@/service/apiService';
import Api from '@/config/api';

export default {
  name: 'Summary',
  data() {
    return {
      summary: {
        total: 0,
        today: 0,
      },
    };
  },
  created() {
    this.loadSummary();
  },
  methods: {
    loadSummary() {
      ApiService.get(Api.endpoints.SUMMARY)
        .then(({ data }) => {
          this.summary = data.data;
        })
        .catch(({ response }) => this.parseErrorResponse(response));
    },
  },
};
</script>

<style scoped>

</style>
